import React, { useState, useEffect, useMemo } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { GetAllCopiedAssemblyCancelToken, getAllCopiedAssembly } from "../../../services/copyIntakeServices";
import DataTableComponent from "../../common/DataTableComponent";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const AllCopiedAssesmblies = ({ id, setShowAllCopiedAssesmblies }) => {
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [studentList, setStudentList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [tableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortKey: "name",
        sortOrder: "desc",
    });

    useEffect(() => {
        const cancelTokenSources = [];
        const getData = async () => {
            setLoading(true);

            cancelTokenSources.forEach(source => {
                source.cancel('New request made');
              });
          
              const source = axios.CancelToken.source();
              cancelTokenSources.push(source);

              const data = {
                uniqueProcessId: id,
                page: tableState.page,
                limit: tableState.perPage,
                key: tableState.sortKey,
                sort: tableState.sortOrder,
                search: search,
            };

            try {
                const res = await GetAllCopiedAssemblyCancelToken(data, source.token);
                setShowAllCopiedAssesmblies(res?.data && res?.data?.list && res?.data?.list?.data.length || search ? true : false)
                setStudentList(
                    res?.data && res?.data?.list && res?.data?.list?.data ? res?.data?.list?.data : []
                );
                setTotalRows(res?.data?.list?.total);
                if (res.status === 200) {
                  setLoading(false);
                }
              } catch (error) {
                if (!axios.isCancel(error)) {
                  console.error(error);
                  setLoading(false);
                }
              }
        };
        getData();

        return () => {
            cancelTokenSources.forEach(source => {
              source.cancel('Component unmounted');
            });
        };
    }, [
        tableState,
        // totalRows,
        search,
    ]);

    const columns = useMemo(() => [
        // {
        //     name: "Id",
        //     selector: "id",
        //     sortField: "id",
        //     sortable: true,
        //     cell: (row) => row?.id,
        // },
        {
            name: "Assesmblies",
            selector: "name",
            sortField: "name",
            sortable: true,
            cell: (row) => (
                <Link
                    className="as-text-blue curser feature-name"
                    title={row.name}
                    to={`/courses/content/assemblies/edit/${row?.assembly_id}`}
                >
                    <span className="textLimit100">{row?.name}</span>
                </Link>
            ),
        },
        {
            name: "Action",
            selector: "",
            // maxWidth: "50px",
            cell: (row) => (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons">
                        <Link
                            className="btn btn-primary rounded-circle"
                            title="Open"
                            to={`/courses/content/assemblies/edit/${row?.assembly_id}`}
                        >
                            <i className="fal fa-folder-open"></i>
                        </Link>
                    </div>
                </div>
            ),
        },
    ]);

    const exportData = (fileType, fileName) => {
        let data;
        const header = ["Assesmblies",];
        const details = {
            uniqueProcessId: id,
            page: tableState.page,
            limit: tableState.perPage,
            key: tableState.sortKey,
            sort: tableState.sortOrder,
            search: search,
            exportStatus: "true",
        };
        GetAllCopiedAssemblyCancelToken(details)
            .then((res) => {
                data = res?.data && res?.data?.list?.length ? res?.data?.list : [];
                data = data?.map((row) => ({
                    ...row,
                    // "Id": row.id ? row.id : "-",
                    "Assesmblies": row?.name ? row?.name : "-",
                }));
                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);

                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = [
                        "text/csv",
                        anchor.download,
                        anchor.href,
                    ].join(":");
                    anchor.click();

                    setTimeout(() => {
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.map((col, index) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                        header,
                    });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);

                    return false;
                }
                if (fileType === "pdf") {
                    const compatibleData = data.map((row) => {
                        return [
                            // row["Id"],
                            row["Assesmblies"],
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);

                    return false;
                }
            })
            .catch((error) => {
                console.log("error =-=--> ", error);
                setLoading(false);
            });
    };

    return (
        <DataTableComponent
            data={studentList}
            loading={loading}
            state={tableState}
            setState={setTableState}
            setSearch={setSearch}
            totalRows={totalRows}
            columns={columns}
            exportFunction={exportData}
            exportFileName={"Assesmblies"}
            isActionAlignRight
        />
    );
};

export default AllCopiedAssesmblies;
